import React from 'react'
import { Navigate } from 'react-router-dom'
import { useTenant } from '../../contexts/TenantContext'
import { getModulesForTenant } from '../../config/modulesByTenant'

interface TenantGuardProps {
  children: React.ReactNode
  requiredTenant?: 'Aco' | 'fashion'
  requiredPath?: string
}

const TenantGuard: React.FC<TenantGuardProps> = ({ children, requiredTenant, requiredPath }) => {
  const { tenantId } = useTenant()
  
  // Se não há tenantId ainda, aguarda (cheque explícito para evitar falsy como 0)
  if (tenantId === null) {
    return <div>Carregando...</div>
  }
  
  // Se requiredTenant foi especificado, verifica diretamente
  if (requiredTenant) {
    const hasAccess = () => {
      if (requiredTenant === 'Aco') {
        return tenantId !== 2 // Aco tenant
      } else if (requiredTenant === 'fashion') {
        return tenantId === 2 // Fashion tenant
      }
      return false
    }

    if (!hasAccess()) {
      return (
        <div style={{ 
          padding: '20px', 
          textAlign: 'center',
          color: '#666',
          fontSize: '16px'
        }}>
          <h3>Acesso Restrito</h3>
          <p>Você não tem permissão para acessar este módulo.</p>
          <p>Este módulo é específico para tenant: {requiredTenant}</p>
        </div>
      )
    }

    return <>{children}</>
  }
  
  // Lógica original para requiredPath
  if (requiredPath) {
    // Verifica se o tenant tem acesso ao módulo
  const availableModules = getModulesForTenant(tenantId)
    const hasAccess = availableModules.some(module => module.path === requiredPath)
    
    if (!hasAccess) {
      // Redireciona para a home se não tem acesso
      return <Navigate to="/panel" replace />
    }
    
    return <>{children}</>
  }

  // Se nem requiredTenant nem requiredPath foram fornecidos, permite acesso
  return <>{children}</>
}

export default TenantGuard